import React from "react";
import { Theme } from "@mui/material/styles";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import { ButtonBaseProps, ButtonGroupProps } from "@mui/material";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonProgress: {
      color: "#002655",
      marginLeft: "16px",
    },
  })
);
interface ButtonProps {
  loading: boolean;
}
type LoadingButtonProps = ButtonProps & ButtonBaseProps & ButtonGroupProps;
const LoadingButton: React.FC<LoadingButtonProps> = (props) => {
  const classes = useStyles();
  const loading = props.loading;
  const newProps: any = { ...props };
  delete newProps.loading;
  return (
    <Button {...newProps} disabled={loading || newProps.disabled}>
      {newProps.children}{" "}
      {loading && (
        <CircularProgress size={20} className={classes.buttonProgress} />
      )}
    </Button>
  );
};

export default LoadingButton;
